import { httpClient } from './httpClient'
import type { PvAveragePriceRequest, PvAveragePriceResponse } from '../dto/shared/PvKostenRechnerDto'

/** Separate from pvToolApi on purpose - different backend controller/data source, see
 *  tasks/new-things/preis-durchschnittsrechner/01-backend-preis-api.md. */
export const pvKostenRechnerApi = {
  calculate: (request: PvAveragePriceRequest) =>
    httpClient.post<PvAveragePriceResponse>('/tools/pv-average-price', request),
}
